import React, {
    useCallback,
    useEffect,
    useRef,
    useState
} from 'react';
import PropTypes               from 'prop-types';
import { Navigation }          from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames              from 'classnames';
import { useDispatch } from 'react-redux';
import Card                    from '../Card';
import useWindowSize           from '../../hooks/useWindowSize';
import useMediaQuery           from '../../hooks/useMediaQuery';
import ArrowLeft               from '../../assets/icon/ArrowLeft';
import ArrowRight              from '../../assets/icon/ArrowRight';
import { addInCart } from '../../store/actions/addInCart';
import { getCart } from '../../store/actions/Cart';
import history from '../../history';
import style                   from './WrapperCard.module.scss';

// eslint-disable-next-line react/prop-types
function WrapperCard({ children, data = [], option, className }) {
    const container = useRef();
    const prev = useRef(null);
    const next = useRef(null);
    const [ margin, setMargin ] = useState('auto');
    const [ width ] = useWindowSize();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width: 1100px)');
    const [ init, setInit ] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line no-shadow
        setInit(true);
    }, [ option ]);

    const initNav = useCallback((swiper) => {
        swiper.params.navigation.prevEl = prev.current;
        swiper.params.navigation.nextEl = next.current;
        swiper.navigation.init();
        swiper.navigation.update();
    }, []);

    const handleClick = useCallback(async (e) => {
        const { target } = e;

        e.preventDefault();

        if (target.closest('button')) {
            const cartInfo = target.closest('button').getAttribute('data-obj');
            const session = localStorage.getItem('sessionId');

            if (cartInfo) {
                const obj = JSON.parse(cartInfo);

                const cart = localStorage.getItem('cart');

                if (cart) {
                    localStorage.setItem('cart', JSON.stringify([ ...JSON.parse(cart), obj ]));
                    // eslint-disable-next-line no-shadow
                    const cartUpdate = localStorage.getItem('cart');

                    const arr = JSON.parse(cartUpdate);

                    const result = arr.reduce((acc, curr) => {
                        // eslint-disable-next-line no-shadow
                        const item = acc.find(item => item.productId === curr.productId);

                        if (item) {
                            item.quantity += curr.quantity;
                        } else {
                            acc.push(curr);
                        }

                        return acc;
                    }, []);

                    localStorage.setItem('cart', JSON.stringify(result));
                } else {
                    localStorage.setItem('cart', JSON.stringify([ obj ]));
                }

                await dispatch(addInCart({ ...obj, ...(session && { sessionId: session }) }));

                await dispatch(getCart());
            }
        } else {
            const cartInfo = target.closest('div').getAttribute('data-link');

            if (cartInfo) {
                history.push(cartInfo);
            }
        }
    }, []);

    useEffect(() => {
        setMargin(container.current.offsetLeft);
    }, [ width ]);

    return (
        <section className={className ? classNames(style['wrapper-card'], className) : style['wrapper-card']} data-wrapper='wrapper-card'>
            <div>
                <div ref={container} className={style.container}>
                    {children}
                </div>

                <div
                    className={style.swiper__inner} style={{
                        marginLeft : margin
                    }}
                    onClick={handleClick}
                >

                    {
                        (init && data?.length > 0) &&
                        <Swiper
                            /* eslint-disable-next-line react/jsx-no-bind */
                            onInit={initNav}
                            className={style.swiper}
                            spaceBetween={isDesktop ? 17 : 13}
                            slidesPerView={1.2}
                            loop
                            modules={[ Navigation ]}
                            breakpoints={{
                                0 : {
                                    slidesPerView : 1.3
                                },
                                450 : {
                                    slidesPerView : 1.7
                                },
                                768 : {
                                    slidesPerView : 2.4
                                },
                                950 : {
                                    slidesPerView : 3.3
                                },
                                1300 : {
                                    slidesPerView : 4.3
                                }
                            }}
                        >
                            {
                                // eslint-disable-next-line react/prop-types
                                data?.map((e, i) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <SwiperSlide key={e?.id} className={classNames(style['swiper-slide'], '--border')}>
                                        <Card
                                            extId={e?.extId}
                                            name={e?.nameUa}
                                            id={e?.id}
                                            price={e?.price}
                                            showcases={e?.showcases}
                                            image={e?.media?.length > 0 ? e?.media[0]?.url : ''}
                                            discounts={e?.discounts}
                                            stock={e?.stock}
                                            i={i}
                                            link={`/product/${e?.id}`}
                                            instructions={e?.instructions}
                                            discountPrice={e?.discountPrice}
                                        />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    }

                    {
                        (init && !data?.length > 0) && <h2 className={'no-data-fetch'}>На даний момент дані відсутні</h2>
                    }

                    {
                        (option?.nav && data?.length > 0) &&
                            <>
                                <button ref={prev} className={classNames(style.prev, 'btn-prev')}>
                                    <ArrowLeft />
                                </button>

                                <button ref={next} className={classNames(style.next, 'btn-next')}>
                                    <ArrowRight />
                                </button>
                            </>
                    }

                </div>
            </div>
        </section>
    );
}

WrapperCard.propTypes = {
    children : PropTypes.node,
    option   : PropTypes.object
};

WrapperCard.defaultProps = {
    children : null,
    option   : null
};

export default React.memo(WrapperCard);
